module.exports = __webpack_public_path__ + "img/dd14a58de00c543f3eaa1a6850e9f46b.png";